import React, {useState, useEffect} from "react";
import UserFlowModal from "../../travellersDetails/components/UserFlow/UserFlowModal";
import {
  getItemBySession,
  itemType
} from 'MMT-UI/storages/client/sessionStorage';
import { STORAGE_CONSTANTS } from "../../../constants/TrainConstants";
import { useSelector } from "react-redux";

const Modal = ({
  currentModal,
  show,
  setShow,
}) => {
  const [userId, setUsername] = useState("");
  const irctcIdFromRedux = useSelector((state) => state?.user?.irctcId);

  useEffect(() => {
    const irctcIdFromStorage = getItemBySession(
      STORAGE_CONSTANTS.VERIFIED_USER_ID,
      { isPiiData: true, shouldParseJson: true },
      itemType.ES
    );
    if (irctcIdFromRedux) {
      setUsername(irctcIdFromRedux);
    } else if (irctcIdFromStorage) {
      setUsername(irctcIdFromStorage)
    }
  }, [irctcIdFromRedux]);

  return (
    <React.Fragment>
      {
        show &&
        <UserFlowModal
          userStatus={{ userId }}
          currentModal={currentModal}
          updateVerifiedUser={() => {}}
          allowClose
          showModal
          closeModal={setShow}
          createAccount={() => {}}
        />
      }
    </React.Fragment>
  )
}

export default Modal;
